<li
  (click)="onClick()"
  [class.selected]="selected"
  [class.disabled]="!selectable && !overrideOnClickEvent"
  [ngClass]="cssClass"
>
  <i [class.multiple]="multiple">
    <svg viewBox="0 0 21.02 14.02">
      <path
        fill-rule="evenodd"
        d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
      />
    </svg>
  </i>
  <div
    [ngStyle]="{
      color: textColor
    }"
  >
    {{ !titleTemplateRef ? title : "" }}
    <ng-template [ngTemplateOutlet]="titleTemplateRef"></ng-template>
  </div>
  <div
    *ngIf="showSettings"
    class="settingIcon settingIconSubs"
    inlineSVG="/assets/icons/pop-edit.svg"
  ></div>
  <div class="defaultOptions" *ngIf="isShowDefaultStatus">
    <div *ngIf="isDefault" class="default">Default</div>
    <div
      *ngIf="!isDefault && selected"
      class="set-default"
      (click)="setAsDefault($event)"
    >
      Set As Default
    </div>
  </div>
</li>
